"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassiveAbility = exports.PassiveOnlyAbility = void 0;
const AbilityType_1 = require("../abilities/AbilityType");
exports.PassiveOnlyAbility = {
    [AbilityType_1.AbilityType.DoubleAttack]: true,
    [AbilityType_1.AbilityType.TripleAttack]: true,
    [AbilityType_1.AbilityType.Radiance]: true,
    [AbilityType_1.AbilityType.ReflectiveCurse]: true,
    [AbilityType_1.AbilityType.CallOfTheWild]: true,
    [AbilityType_1.AbilityType.FlamesOfWar]: true,
    [AbilityType_1.AbilityType.HotStreak]: true,
    [AbilityType_1.AbilityType.DivineResolution]: true,
    [AbilityType_1.AbilityType.CommandingPresence]: true,
    [AbilityType_1.AbilityType.DramaticEndings]: true,
    [AbilityType_1.AbilityType.GazeOfPetrification]: true,
    [AbilityType_1.AbilityType.CautiousAim]: true,
    [AbilityType_1.AbilityType.KillingMachine]: true,
    [AbilityType_1.AbilityType.MasterSharpshooter]: true,
    [AbilityType_1.AbilityType.MasterOfPoisons]: true,
    [AbilityType_1.AbilityType.FieryEnding]: true,
    [AbilityType_1.AbilityType.HiveMother]: true,
    [AbilityType_1.AbilityType.HellsFury]: true,
    [AbilityType_1.AbilityType.HellsRetribution]: true,
    [AbilityType_1.AbilityType.ElementalShockFire]: true,
    [AbilityType_1.AbilityType.ElementalShockFrost]: true,
    [AbilityType_1.AbilityType.ElementalShockNature]: true,
    [AbilityType_1.AbilityType.ElementalShockSonic]: true,
    [AbilityType_1.AbilityType.HymnOfHeimdall]: true,
    [AbilityType_1.AbilityType.HealingRhythm]: true,
    [AbilityType_1.AbilityType.HishasHarmony]: true,
    [AbilityType_1.AbilityType.ShockShield]: true,
    [AbilityType_1.AbilityType.Vengeance]: true,
    [AbilityType_1.AbilityType.Revenge]: true,
    [AbilityType_1.AbilityType.OutOfTime]: true,
    [AbilityType_1.AbilityType.Twincast]: true,
    [AbilityType_1.AbilityType.Mirage]: true,
    [AbilityType_1.AbilityType.Continuance]: true,
    [AbilityType_1.AbilityType.ChillyEmpowerment]: true,
};
exports.PassiveAbility = {
    ...exports.PassiveOnlyAbility,
    [AbilityType_1.AbilityType.SigilOfBlood]: true,
    [AbilityType_1.AbilityType.SigilOfDamnation]: true,
    [AbilityType_1.AbilityType.SigilOfTheDamken]: true,
};
